import React from 'react';
import { Oval } from 'react-loader-spinner'; // Import the Oval loader

const AdminLoader = () => {
    return (
        <div className="admin-loader-container d-flex justify-content-center" >
            <Oval
                height={50}        // Loader height
                width={50}         // Loader width
                color="blue"    // Customize loader color
                ariaLabel="oval-loading"  // Accessibility label
                visible={true}     // Make it visible
            />
        </div>
    );
};

export default AdminLoader;